import { renChaosnet, renDevnet, renLocalnet, renMainnet, renTestnet, } from "@renproject/contracts";
export const stringToNetwork = (network) => {
    if (typeof network === "string") {
        switch (network.toLowerCase()) {
            case "":
            case "mainnet":
                return renMainnet;
            case "chaosnet":
                return renChaosnet;
            case "testnet":
                return renTestnet;
            case "devnet":
                return renDevnet;
            // case "localnet":
            //     return localnet;
            default:
                throw new Error(`Unsupported network "${network}"`);
        }
    }
    else if (network === undefined || network === null) {
        return renMainnet;
    }
    else {
        return network;
    }
};
export const NetworkDetails = {
    Mainnet: renMainnet,
    Chaosnet: renChaosnet,
    Testnet: renTestnet,
    Devnet: renDevnet,
    Localnet: renLocalnet,
    stringToNetwork,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmV0d29ya3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbmV0d29ya3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUNILFdBQVcsRUFDWCxTQUFTLEVBQ1QsV0FBVyxFQUNYLFVBQVUsRUFFVixVQUFVLEdBQ2IsTUFBTSx1QkFBdUIsQ0FBQztBQUUvQixNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUcsQ0FDM0IsT0FBdUQsRUFDdEMsRUFBRTtJQUNuQixJQUFJLE9BQU8sT0FBTyxLQUFLLFFBQVEsRUFBRTtRQUM3QixRQUFRLE9BQU8sQ0FBQyxXQUFXLEVBQUUsRUFBRTtZQUMzQixLQUFLLEVBQUUsQ0FBQztZQUNSLEtBQUssU0FBUztnQkFDVixPQUFPLFVBQVUsQ0FBQztZQUN0QixLQUFLLFVBQVU7Z0JBQ1gsT0FBTyxXQUFXLENBQUM7WUFDdkIsS0FBSyxTQUFTO2dCQUNWLE9BQU8sVUFBVSxDQUFDO1lBQ3RCLEtBQUssUUFBUTtnQkFDVCxPQUFPLFNBQVMsQ0FBQztZQUNyQixtQkFBbUI7WUFDbkIsdUJBQXVCO1lBQ3ZCO2dCQUNJLE1BQU0sSUFBSSxLQUFLLENBQUMsd0JBQXdCLE9BQU8sR0FBRyxDQUFDLENBQUM7U0FDM0Q7S0FDSjtTQUFNLElBQUksT0FBTyxLQUFLLFNBQVMsSUFBSSxPQUFPLEtBQUssSUFBSSxFQUFFO1FBQ2xELE9BQU8sVUFBVSxDQUFDO0tBQ3JCO1NBQU07UUFDSCxPQUFPLE9BQU8sQ0FBQztLQUNsQjtBQUNMLENBQUMsQ0FBQztBQVdGLE1BQU0sQ0FBQyxNQUFNLGNBQWMsR0FBbUI7SUFDMUMsT0FBTyxFQUFFLFVBQVU7SUFDbkIsUUFBUSxFQUFFLFdBQVc7SUFDckIsT0FBTyxFQUFFLFVBQVU7SUFDbkIsTUFBTSxFQUFFLFNBQVM7SUFDakIsUUFBUSxFQUFFLFdBQVc7SUFFckIsZUFBZTtDQUNsQixDQUFDIn0=